(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // 初始状态隐藏所有产品列表
    const productLists = document.querySelectorAll('#menu-drawer .product-list');
    productLists.forEach(list => {
      list.style.display = 'none';
    });
    
    // 为顶层菜单项添加点击事件
    const topNavs = document.querySelectorAll('#menu-drawer .top_nav');
    topNavs.forEach(topNav => {
      topNav.addEventListener('click', function() {
        const mainList = this.parentElement.querySelector('.main-collection-list');
        if (mainList) {
          if (mainList.style.display === 'none' || !mainList.style.display) {
            mainList.style.display = 'block';
            const arrow = this.querySelector('svg');
            if (arrow) {
              arrow.style.transform = 'rotate(180deg)';
              arrow.style.transition = 'transform 0.3s';
            }
          } else {
            mainList.style.display = 'none';
            const arrow = this.querySelector('svg');
            if (arrow) {
              arrow.style.transform = 'rotate(0)';
            }
          }
        }
      });
    });
    
    // 为所有子集合标题添加点击事件
    const subCollectionTitles = document.querySelectorAll('#menu-drawer .sub-collection-title');
    subCollectionTitles.forEach(title => {
      title.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // 获取相邻的产品列表元素
        const productList = this.nextElementSibling;
        
        // 切换显示/隐藏状态
        if (productList.style.display === 'none' || !productList.style.display) {
          productList.style.display = 'flex';
          // 旋转箭头
          const arrow = this.querySelector('svg');
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
            arrow.style.transition = 'transform 0.3s';
          }
        } else {
          productList.style.display = 'none';
          // 恢复箭头
          const arrow = this.querySelector('svg');
          if (arrow) {
            arrow.style.transform = 'rotate(0)';
          }
        }
      });
    });
    // 初始隐藏主类别列表
    const mainCollectionLists = document.querySelectorAll('#menu-drawer .main-collection-list');
    mainCollectionLists.forEach(list => {
      list.style.display = 'none';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
